/**
 * 発注関連ロジック
 */
class LessonFromOptions
{
    /**
     * 〇月〇旬のSELECTオプション生成
     *
     * @return object[]
     */
    static generate(year)
    {
        let lesson_from_options = [];

        let y = year;
        let j_text = '';
        for (let n of [4,5,6,7,8,9,10,11,12,1,2,3]) {
            if (n < 4) {
                y = year + 1;
            }
            for (let j of [1,11,21]) {
                if (j === 1) {
                    j_text = '上旬';
                } else if (j === 11) {
                    j_text = '中旬';
                } else {
                    j_text = '下旬';
                }

                lesson_from_options.push({
                    key: y + '-' + ("00" + n).slice( -2 ) + '-' + ("00" + j).slice( -2 ),
                    label: n + '月' + j_text,
                });
            }
        }

        return lesson_from_options;
    }
}

export default LessonFromOptions;